export default __webpack_public_path__ + "static/2019_03-72af2e0b47a6b4f1674568260b744903.png";